import createAction from './';


export const ADD_APPOINTMENT_TO_LIST = createAction('ADD_APPOINTMENT_TO_LIST');
export const REMOVE_APPOINTMENT_FROM_LIST = createAction('REMOVE_APPOINTMENT_FROM_LIST');
export const UPDATE_EXISTING_APPOINTMENT = createAction('UPDATE_EXISTING_APPOINTMENT');


export const updateExistingAppointment = (appointment, currentPosition, updatedPosition, listQueueType) => ({
  type: UPDATE_EXISTING_APPOINTMENT,
  payload: {
    listQueueType,
    appointment,
    currentPosition,
    updatedPosition,
  },
});
export const addAppointmentToList = (appointment, position, listQueueType) => ({
  type: ADD_APPOINTMENT_TO_LIST,
  payload: {
    listQueueType,
    appointment,
    position,
  },
});
export const removeAppointmentFromList = (appointmentId, listQueueType) => dispatch => {
  return dispatch({
    type: REMOVE_APPOINTMENT_FROM_LIST,
    payload: {
      listQueueType,
      appointmentId,
    },
  });
};
